<div class="edit-user">
  <div class="container">
    <div class="d-flex justify-content-between container" *ngIf="isInitialised">
      <h1 *ngIf="!user.id">Maak nieuwe gebruiker</h1>

      <h1 *ngIf="user.id > 0">{{ displayFormTitle() }}</h1>

      <div *ngIf="currentUserIsAdmin">
        <button
          class="button"
          type="button"
          (click)="router.navigateByUrl(returnRoute)"
          class="btn btn-main btn-back"
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="isLoadingObject" style="align-self: center">
      <mat-spinner
        style="margin: auto"
        color="primary"
        diameter="48"
      ></mat-spinner>
    </div>

    <div *ngIf="isInitialised">
      <div>
        <form
          [formGroup]="userForm"
          role="form"
          autocomplete="off"
          id="formLogin"
          novalidate=""
          (submit)="save()"
        >
          <mat-card class="mat-elevation-z0 padding">
            <div *ngIf="currentUserIsAdmin" class="form-title font-weight-bold">
              Algemeen
            </div>

            <div class="form-sub-title">Foto</div>

            <div class="appelflap">
              <div class="rounded-circle employee-initials">
                <span
                  *ngIf="!this.user.profilePicture"
                  class="employee-initials rounded-circle in-the-middle no-margin"
                >
                  {{ getLettres() }}
                </span>

                <div *ngIf="this.user.profilePicture" class="in-the-middle">
                  <img
                    class="rounded-circle"
                    *ngIf="isImage(user.profilePicture)"
                    src="/api/assets/{{ user.profilePicture.uuid }}"
                    width="120px"
                    height="120px"
                  />
                </div>
              </div>

              <div class="d-flex">
                <button
                  class="btn button no-margin button-width"
                  type="button"
                  (click)="fileInput.click()"
                >
                  <span>Bestand uploaden</span>

                  <input
                    #fileInput
                    type="file"
                    style="display: none"
                    ng2FileSelect
                    [uploader]="uploader"
                    (onFileSelected)="fileAdded($event)"
                    accept=".png,.jpg,.jpeg,.pdf,image/png,image/jpg,image/jpeg,application/pdf"
                  />
                </button>

                <button
                  *ngIf="currentUserIsAdmin && user.id != null"
                  class="btn button resend-button"
                  type="button"
                  (click)="resendLoginEmail()"
                >
                  Login mail opnieuw versturen
                </button>
              </div>
            </div>

            <div class="form-sub-title upper-space">Gegevens</div>

            <div class="d-flex justify-content-between">
              <mat-form-field class="form-field no-margin" appearance="outline">
                <mat-label>Voornaam</mat-label>

                <input
                  matInput
                  type="text"
                  required
                  formControlName="firstName"
                  [placeholder]="'Voornaam'"
                />

                <mat-error *ngIf="userForm.controls.firstName.errors?.required">
                  Voornaam is vereist
                </mat-error>

                <mat-error
                  *ngIf="userForm.controls.firstName.errors?.minlength"
                >
                  Lengte moet minstens 3 tekens zijn
                </mat-error>
              </mat-form-field>

              <mat-form-field class="form-field" appearance="outline">
                <mat-label>Achternaam</mat-label>

                <input
                  matInput
                  type="text"
                  required
                  formControlName="lastName"
                  [placeholder]="'Familienaam'"
                />

                <mat-error *ngIf="userForm.controls.lastName.errors?.required">
                  Achternaam is vereist
                </mat-error>

                <mat-error *ngIf="userForm.controls.lastName.errors?.minlength">
                  Lengte moet minstens 3 tekens zijn
                </mat-error>
              </mat-form-field>

              <mat-form-field
                class="form-field no-margin-left"
                appearance="outline"
              >
                <mat-label>Email</mat-label>

                <input
                  matInput
                  type="text"
                  email
                  required
                  formControlName="email"
                  [placeholder]="'Email'"
                />

                <mat-error *ngIf="userForm.controls.email.errors?.required">
                  Dit is een verplicht veld
                </mat-error>

                <mat-error *ngIf="userForm.controls.email.errors?.minlength">
                  Lengte moet minstens 3 tekens zijn
                </mat-error>

                <mat-error *ngIf="userForm.controls.email.errors?.email">
                  Geen geldig email adres
                </mat-error>
              </mat-form-field>

              <mat-form-field class="form-field no-margin" appearance="outline">
                <mat-label>External Party</mat-label>

                <mat-select
                  matInput
                  formControlName="party"
                  placeholder="Maak een keuze"
                >
                  <mat-option
                    *ngFor="let option of externalParties"
                    [value]="option"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-card>
        </form>

        <div class="float-right">
          <button
            *ngIf="!saving"
            type="button"
            (click)="save()"
            mat-button
            class="button"
            id="btnLogin"
            [disabled]="!userForm.valid"
          >
            Opslaan
          </button>

          <mat-spinner
            *ngIf="saving"
            class="top-space"
            color="primary"
            diameter="24"
          ></mat-spinner>
        </div>
      </div>
    </div>
  </div>
</div>
